<div [formGroup]="productsForm">

    <h2>{{headline}}</h2>

    <ng-container *ngIf="productsForm.get('products')['controls'].length">

        <div formArrayName="products"
             *ngFor="let item of productsForm.get('products')['controls']; let i = index">

            <ng-container *ngIf="!singleSelection">
                <p>{{ 'workflows.formWidgets.productList.numberedProduct' | translate: { index: i + 1 } }}</p>
            </ng-container>

            <div [formGroupName]="i"
                 fxLayout="row wrap"
                 fxLayoutGap="12px grid">

                <div fxFlex="100" fxLayout="row" fxLayoutAlign="start start">
                    <mat-form-field [appearance]="appearance" fxFlex="100" floatLabel="always">
                        <mat-label>{{ 'workflows.formWidgets.productList.selectProduct' | translate }}</mat-label>
                        <input type="text" matInput data-test="FI-Produkte durchsuchen..."
                               autocomplete="new-password"
                               formControlName="product"
                               [matAutocomplete]="productSelector">
                        <mat-hint *ngIf="item.get('product').value">
                            <bcm-product-price-label></bcm-product-price-label>
                            : {{ (item.get('price').value ?? item.get('product').value?.price) | bcmDynamicCurrency: '1.2-2' }}
                            / <ng-container *ngIf="item.get('product').value?.unit?.translationKey as uk">{{ uk | unitTypesField:'name' }}</ng-container>
                            <ng-container *ngIf="item.get('dynamicPrice').value?.ruleName as ruleName">
                                — {{ 'workflows.formWidgets.productList.dynamicPriceRuleHint' | translate: { rule: ruleName } }}
                            </ng-container>
                        </mat-hint>
                        <mat-error>{{item.get('product').errors | firstErrorMessage}}</mat-error>
                    </mat-form-field>

                    <mat-autocomplete #productSelector="matAutocomplete" [displayWith]="displayProductWith">
                        <mat-option *ngFor="let product of (filteredProductsList$[i] | async)" [value]="product">
                            <span>{{ product.name }}</span>
                            <small> | {{product.price | bcmDynamicCurrency: '1.2-2'}}</small>
                        </mat-option>
                    </mat-autocomplete>
                </div>

                <mat-form-field [appearance]="appearance" [fxFlex]="singleSelection ? 100 : 85" floatLabel="always">
                    <mat-label>{{ 'table.quantityUnits' | translate }}</mat-label>
                    <app-input-number
                            matInput
                            data-test="FI-Anzahl / Einheiten"
                            formControlName="quantity"
                            [step]="1"
                            [min]="0"></app-input-number>
                    <mat-error>{{item.get('quantity').errors | firstErrorMessage}}</mat-error>
                </mat-form-field>

                <ng-container *ngIf="!singleSelection">
                    <div fxFlex="15">
                        <button data-test="B-Produkt entfernen"
                                mat-button
                                [matTooltip]="'workflows.formWidgets.productList.removeProduct' | translate"
                                [matTooltipPosition]="'above'"
                                class="mat-error"
                                (click)="removeProduct($event, i)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </ng-container>
            </div>

            <!-- Same criteria capture as the invoice position dialog, so a product priced by rules
                 (e.g. relation "Landlieger Katamaran") reaches the contract with its rule price
                 instead of the fixed one. (#6959) -->
            <ng-container *ngIf="hasDynamicPrice(item)">
                <product-dynamic-price [parentFormGroup]="item"
                                       [product]="item.get('product').value"
                                       [dynamicPriceContext]="dynamicPriceContext"
                                       [berthAssignments]="berthAssignments"
                                       [defaultBerthReservationTimeUnit]="defaultBerthReservationTimeUnit"
                                       [useDynamicPrice]="useDynamicPrice[i]"
                                       (dynamicPriceChanged)="onDynamicPriceChanged(i, $event)"
                                       (dynamicPriceErrorChanged)="onDynamicPriceErrorChanged(i, $event)"
                                       (useDynamicPriceChanged)="onUseDynamicPriceChanged(i, $event)"></product-dynamic-price>
            </ng-container>

            <ng-container *ngIf="!singleSelection">
                <mat-divider class="my-16"></mat-divider>
            </ng-container>
        </div>

    </ng-container>

    <ng-container *ngIf="!singleSelection">
        <button data-test="B-Produkt hinzufügen"
                mat-button
                color="accent"
                (click)="addProduct($event)">
            <mat-icon>add_circle</mat-icon>
            {{ 'workflows.formWidgets.productList.addProduct' | translate }}
        </button>
    </ng-container>
</div>
